import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CardRegistrationComponent } from './card-registration-form/card-registration.component';
import { ErrorComponent } from './error/error.component';
import { VersionCheckComponent } from './version-check/version-check.component';



const routes: Routes = [
  {
    path: '',
    component: CardRegistrationComponent
  },
  {
    path: 'home',
    component: CardRegistrationComponent
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: 'version', component: VersionCheckComponent
    ,
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
